import React, { useState, useEffect } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Grid, Typography, MenuItem, Card } from "@mui/material";
import dayjs from "dayjs";
import { StyledTextField, StyledDatePicker, theme } from "../StyledComponents";
import { durationType } from "../initialData/initialData";

const FollowUp = ({
  sectionName,
  activeSection,
  data,
  setData,
  setFollowUpError,
  followUpError,
  details,
  setDetails,
  dateForAppointment
}) => {
  console.log(details);
  console.log("dateForAppointment", dateForAppointment);
  const [validationErrors, setValidationErrors] = useState(followUpError);

  const handleInputChange = (field, value) => {
    let updatedDetails = { ...details, [field]: value };

    // Calculate Date from Duration
    if (
      (field === "duration" || field === "durationType") &&
      updatedDetails.duration &&
      updatedDetails.durationType
    ) {
      const duration = parseInt(updatedDetails.duration);

      if (!isNaN(duration)) {
        updatedDetails.start_date = dayjs(dateForAppointment)
          .add(duration, updatedDetails.durationType)
          .toISOString();
      } else {
        updatedDetails.start_date = null;
      }
    } else {
      updatedDetails.start_date = null;
    }

    // Calculate Duration from Date
    // if (field === "start_date" && value && updatedDetails.durationType) {
    //   const diff = dayjs(value).diff(
    //     dayjs(),
    //     updatedDetails.durationType,
    //     true
    //   );
    //   updatedDetails.duration = Math.round(diff);
    // }

    const newDetails = [
      { ...updatedDetails, durationType: updatedDetails.durationType },
    ];
    setDetails(updatedDetails);
    setData(newDetails);
    validateFields(updatedDetails);
  };

  const validateFields = (detail) => {
    const errors = {};

    // if (!detail.duration && detail.service_type) {
    //   errors.duration =
    //     "Follow-up duration is required if any other field is selected.";
    // }

    if (detail.start_date && !detail.service_type) {
      errors.service_type =
        "Description is required if follow-up duration is selected.";
    }

    if (detail.duration && isNaN(detail.duration)) {
      errors.duration = "Duration must be a number.";
    }

    setValidationErrors(errors);
    setFollowUpError(errors);
  };

  useEffect(() => {
    if (!details.durationType) {
      const updatedDetails = { ...details, durationType: "days" };
      setDetails(updatedDetails);
      setData([updatedDetails]);
    }
  }, []);

  // Calculate Date from Duration
  useEffect(() => {
    const { duration, durationType } = details;
    if (duration && durationType) {
      const newDate = dayjs(dateForAppointment).add(Number(duration), durationType).toISOString();
      const updatedDetails = { ...details, start_date: newDate };
      setDetails(updatedDetails);
      setData([updatedDetails]);
    }
  }, [details.duration, details.durationType]);

  return (
    <ThemeProvider theme={theme}>
      {activeSection ? (
        <Card
          sx={{
            borderRadius: "10px",
            boxShadow: "0 4px 4px 0 #C7C7CC inset",
            backgroundColor: "#FFF",
          }}
        >
          <Grid item xs={12}>
            <Typography
              sx={{ marginLeft: 1 }}
              color="textPrimary"
              style={{ marginTop: "1%" }}
            >
              Follow Up
            </Typography>
            <Grid container spacing={2} sx={{ padding: "10px" }}>
              <Grid item xs={6} sm={6} md={6}>
                <StyledTextField
                  fullWidth
                  label="Follow-up Description"
                  value={details.service_type || ""}
                  onChange={(e) =>
                    handleInputChange("service_type", e.target.value)
                  }
                  error={!!validationErrors.service_type}
                  helperText={validationErrors.service_type}
                />
              </Grid>

              <Grid item xs={6} sm={3} md={3}>
                {/* <StyledTextField
                label="Duration"
                fullWidth
                value={details.duration || ""}
                error={!!validationErrors.duration}
                helperText={validationErrors.duration}
                onChange={(e) => handleInputChange("duration", e.target.value)}
              /> */}
                <StyledTextField
                  label="Duration"
                  fullWidth
                  type="number"
                  value={details.duration || ""}
                  error={!!validationErrors.duration}
                  helperText={validationErrors.duration}
                  onChange={(e) =>
                    handleInputChange("duration", e.target.value)
                  }
                  onWheel={(e) => e.target.blur()} // Prevent scroll change
                  InputProps={{
                    inputProps: {
                      style: {
                        // Hide arrows in Chrome, Safari, Edge
                        MozAppearance: "textfield",
                      },
                    },
                    sx: {
                      // Hide arrows in Firefox
                      "& input[type=number]": {
                        MozAppearance: "textfield",
                      },
                      // Hide arrows in Chrome, Safari, Edge
                      "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button":
                      {
                        WebkitAppearance: "none",
                        margin: 0,
                      },
                    },
                  }}
                />
              </Grid>

              <Grid item xs={6} sm={3} md={3}>
                <StyledTextField
                  select
                  fullWidth
                  label="Duration Type"
                  value={details.durationType || "days"}
                  onChange={(e) =>
                    handleInputChange("durationType", e.target.value)
                  }
                >
                  {durationType.map((type) => (
                    <MenuItem
                      key={type.value}
                      value={type.value}
                      sx={{ fontSize: "12px" }}
                    >
                      {type.display}
                    </MenuItem>
                  ))}
                </StyledTextField>
              </Grid>

              <Grid item xs={6} sm={3} sx={{ display: "none" }}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <StyledDatePicker
                    label="Follow-up Date"
                    format="DD-MM-YYYY"
                    onChange={(date) => {
                      const formattedDate = date
                        ? dayjs(date).toISOString()
                        : null;
                      handleInputChange("start_date", formattedDate);
                    }}
                    minDate={dayjs()}
                    slotProps={{
                      textField: {
                        error: !!validationErrors.start_date,
                        helperText: validationErrors.start_date,
                      },
                      field: { clearable: true },
                    }}
                    value={
                      details?.start_date ? dayjs(details.start_date) : null
                    }
                  />
                </LocalizationProvider>
              </Grid>
            </Grid>
          </Grid>
        </Card>
      ) : null}
    </ThemeProvider>
  );
};

export default FollowUp;
